module.exports = __webpack_public_path__ + "img/how.ad40fc01.jpg";